export const arrayNames = [
	'custom_classes',
	'details_data_exclusion',
	'filter',
	'modifier_classes',
	'custom_classes_1',
	'custom_classes_2',
	'custom_classes_3',
	'modifier_classes_1',
	'modifier_classes_2',
	'modifier_classes_3',
	'line_custom_classes',
	'line_modifier_classes',
	'box_custom_classes',
	'container_classes',
	'container_custom_classes',
	'content_classes',
	'content_custom_classes',
	'condor_layout_classes',
];

export const exclusions = [
	'default_list_shown',
];

export const monarchExclusions = [
	'monarch_feed_ap_showbiz_and_newsminute_dailies',
	'monarch_feed_ap_top_news_videos',
	'monarch_feed_community_calendar',
	'monarch_feed_creature_features',
	'monarch_feed_destinations',
	'monarch_feed_digital_broadcaster_package',
	'monarch_feed_global_top_news_videos',
	'monarch_feed_health_news_2_pak',
	'monarch_feed_innovations',
	'monarch_feed_knowmore_living',
	'monarch_feed_local_health_conditions',
	'monarch_feed_reuters_entertainment_news_videos',
	'monarch_feed_the_canadian_press',
	'monarch_feed_video_news_bites',
	'monarch_feed_weather_forecast_videos',
	'monarch_feed_window_to_our_world',
];

export const pendingDeprecated = [
	'monarch_feed_local_health_conditions',
	'monarch_feed_weather_forecast_videos',
	'monarch_feed_window_to_our_world',
	'monarch_feed_financial_graphics',
	'monarch_feed_weather_graphics',
];

export const componentTypeExclusions = {
	'brood': [
		'transition_in',
		'transition_out',
	],
	'monarch': [
		'transition_in',
		'transition_out',
	],
	'nova': [
		'transition_in',
		'transition_out',
	],
	'peacock': [
		'transition_in',
		'transition_out',
	],
	'pelican': [
		'transition_in',
		'transition_out',
	],
};

export const unusedSettingsGeneric = [
	'condor_theme_variation',
	'condor_render_name',
	'zip_code',
	'monarch_location',
	'static_map_latitude',
	'static_map_longitude',
	'google_tag_manager_id',
	'traffic_pin_yah_letter',
	'traffic_pin_yah_color',
];

export const jsonTypes = {
	raven_days: '[]',
};

export const unusedSettingsSpecific = {
	animated_scroller: [
		'animation_level',
	],
	info_box: [
		'custom_classes', 'header', 'header_block', 'img', 'info_box_text',
	],
	info_box_group: [
		'header_block_display', 'header_display', 'line_seperator',
	],
	listing_collection: [
		'vertical_line_style', 'vertical_line_width',
	],
	listing_group: [
		'column_line_width', 'id_name', 'labels', 'layout', 'listing_static_labels', 'show_column_line_first', 'show_column_line_last', 'show_column_lines', 'show_listing_background', 'style_parent_header',
	],
	news: [
		'format',
	],
	weather: [
		'line', 'refresh_time_mins', 'title',
	],
	mobile_url: [
		'custom_classes', 'custom_content_sidebar_label', 'custom_portal_label', 'is_locked', 'layout_order',
	],
	dynamic_map_amenities: [
		'dynamic_map_popup_pin_url', 'dynamic_map_yah_pin_url',
	],
	traffic_map: [
		'traffic_line_before_layer',
		'traffic_line_color_heavy',
		'traffic_line_color_low',
		'traffic_line_color_moderate',
		'traffic_line_color_severe',
		'traffic_line_width',
	],
	peacock: [
		'file_size_limit',
	],
	nova: [
		'file_size_limit',
	],
};

export const readOnlySettingsSpecific = {
	top_level_condor: [
		'condor_component_group', 'condor_configuration', 'condor_theme',
	],
	raven_display: [
		'calendar_id',
	],
	nova: [
		'venue_id', 'dmn_operator',
	],
	peacock: [
		'venue_id',
	],
	vistar: [
		'venue_id',
	],
};

export const readOnlySystemGroupSettingsSpecific = {
	weather: [
		'zip_code',
	],
	static_map: [
		'static_map_latitude', 'static_map_longitude',
	],
	dynamic_map_traffic: [
		'static_map_latitude', 'static_map_longitude',
	],
	monarch_feed_community_calendar: [
		'monarch_location',
	],
	monarch_feed_traffic_graphics: [
		'monarch_location',
	],
	nova: [
		'project_number',
	],
	peacock: [
		'project_number',
	],
};

export const listingGroupDropdownOptions = {
	text_align: [
		{
			value: 0,
			label: 'Left',
		},
		{
			value: 1,
			label: 'Center',
		},
		{
			value: 2,
			label: 'Right',
		},
	],
	mobile_text_align: [
		{
			value: 0,
			label: 'Left',
		},
		{
			value: 1,
			label: 'Center',
		},
		{
			value: 2,
			label: 'Right',
		},
	],
	label_seperator: [
		{
			value: 0,
			label: ' ',
		},
		{
			value: 1,
			label: ': ',
		},
		{
			value: 2,
			label: ' - ',
		},
	],
};

export const listingGroupDropdownValues =  {
	text_align: {
		0: {
			label: 'Left',
		},
		1: {
			label: 'Center',
		},
		2: {
			label: 'Right',
		},
	},
	mobile_text_align: {
		0: {
			label: 'Left',
		},
		1: {
			label: 'Center',
		},
		2: {
			label: 'Right',
		},
	},
	label_seperator: {
		0: {
			label: ' ',
		},
		1: {
			label: ': ',
		},
		2: {
			label: ' - ',
		},
	},
};

export const multipleSelectionValues = {
	monarch_feed_news_in_pictures_3_pak: {
		monarch__category: [
			{
				label: 'News',
				value: 'news',
			},
			{
				label: 'Sports',
				value: 'sports',
			},
			{
				label: 'Celebrity',
				value: 'celebrity',
			},
		],
	},
	monarch_feed_sports_central: {
		monarch_league: [
			{
				label: 'Major League Baseball',
				value: 'MLB',
			},
			{
				label: 'National Basketball Association',
				value: 'NBA',
			},
			{
				label: 'National Football League',
				value: 'NFL',
			},
			{
				label: 'National Hockey League',
				value: 'NHL',
			},
			{
				label: 'Major League Soccer',
				value: 'MLS',
			},
			{
				label: 'NCAA Mens Football',
				value: 'NCAAMensFootball',
			},
			{
				label: 'NCAA Mens Football 1AA',
				value: 'NCAAMensFootball1aa',
			},
			{
				label: 'NCAA Mens Basketball',
				value: 'NCAAMensBasketball',
			},
			{
				label: 'Professional Golfers\' Association',
				value: 'PGA',
			},
		],
	},
	dynamic_map_amenities: {
		dynamic_map_categories: [
			{
				value: 'Restaurant',
				label: 'Restaurant',
			},
			{
				value: 'Coffee Shop',
				label: 'Coffee Shop',
			},
			{
				value: 'Hotel',
				label: 'Hotel',
			},
			{
				value: 'Bank',
				label: 'Bank',
			},
			{
				value: 'ATM',
				label: 'ATM',
			},
			{
				value: 'Gas Station',
				label: 'Gas Station',
			},
			{
				value: 'Pharmacy',
				label: 'Pharmacy',
			},
			{
				value: 'Train Station',
				label: 'Train Station',
			},
			{
				value: 'Bar or Pub',
				label: 'Bar or Pub',
			},
		],
	},
	amenities_map: {
		amenity_categories: [
			{
				value: '13065',
				label: 'Restaurant',
			},
			{
				value: '13032',
				label: 'Café',
			},
			{
				value: '19009',
				label: 'Lodging',
			},
			{
				value: '11045',
				label: 'Bank',
			},
			{
				value: '19007',
				label: 'Gas Station',
			},
			{
				value: '17029',
				label: 'Convenience Store',
			},
			{
				value: '11044',
				label: 'ATM',
			},
			{
				value: '17069',
				label: 'Grocery',
			},
			{
				value: '17035',
				label: 'Pharmacy',
			},
			{
				value: '17114',
				label: 'Shopping Mall',
			},
			{
				value: '18021',
				label: 'Gym',
			},
			{
				value: '11061',
				label: 'Health & Beauty',
			},
			{
				value: '11073',
				label: 'Spa',
			},
			{
				value: '17056',
				label: 'Florist',
			},
			{
				value: '17089',
				label: 'Gifts',
			},
			{
				value: '15014',
				label: 'Hospital',
			},
			{
				value: '12075',
				label: 'Post Office',
			},
			{
				value: '19047',
				label: 'Rail Station',
			},
			{
				value: '11011',
				label: 'Car Wash',
			},
			{
				value: '12098',
				label: 'Spiritual Center',
			},
			{
				value: '12080',
				label: 'Library',
			},
			{
				value: '16032',
				label: 'Park',
			},
			{
				value: '10027',
				label: 'Museum',
			},
			{
				value: '10024',
				label: 'Movie Theater',
			},
			{
				value: '13003',
				label: 'Bar',
			},
			{
				value: '10032',
				label: 'Night Club',
			},
			{
				value: '17076',
				label: 'Liquor Store',
			},
			{
				value: '13002',
				label: 'Bakery',
			},
			{
				value: '17018',
				label: 'Bookstore',
			},
			{
				value: '11066',
				label: 'Dry Cleaner',
			},
			{
				value: '11069',
				label: 'Laundry',
			},
			{
				value: '17043',
				label: 'Clothing Store',
			},
			{
				value: '17023',
				label: 'Electronics Store',
			},
			{
				value: '17090',
				label: 'Hardware Store',
			},
		].sort((a, b) => {
			if (a.label > b.label) {
				return 1;
			}
			return -1;
		}),
	},
};

export const numberRanges = {
	broadsign_feed: {
		playlist_duration: {
			max: 1440,
			min: 1,
		},
		polling_rate: {
			max: 1440,
			min: 1,
		},
	},
	monarch: {
		limit: {
			max: 10,
			min: 1,
		},
	},
	monarch_feed_reuters_business_news: {
		monarch_limit: {
			max: 100,
			min: 1,
		},
	},
	monarch_feed_reuters_business_news_videos: {
		monarch_limit: {
			max: 10,
			min: 1,
		},
	},
	monarch_feed_flight_info_arrivals: {
		monarch_limit: {
			max: 100,
			min: 1,
		},
	},
	monarch_feed_flight_info_departures: {
		monarch_limit: {
			max: 100,
			min: 1,
		},
	},
	monarch_feed_traffic_graphics: {
		monarch_limit: {
			max: 4,
			min: 4,
		},
	},
	monarch_feed_ap_celebrity_extra: {
		monarch_limit: {
			max: 100,
			min: 1,
		},
	},
	'monarch_feed_ap_entertainment_&_lifestyle_news_videos': {
		monarch_limit: {
			max: 100,
			min: 1,
		},
	},
	monarch_feed_ap_showbiz_and_newsminute_dailies: {
		monarch_limit: {
			max: 100,
			min: 1,
		},
	},
	monarch_feed_global_entertainment_news_videos: {
		monarch_limit: {
			max: 100,
			min: 1,
		},
	},
	monarch_feed_bright_spots_videos: {
		monarch_limit: {
			max: 100,
			min: 1,
		},
	},
	monarch_feed_good_news_videos: {
		monarch_limit: {
			max: 100,
			min: 1,
		},
	},
	monarch_feed_local_favorites: {
		monarch_limit: {
			max: 100,
			min: 1,
		},
	},
	monarch_feed_reuters_entertainment_news: {
		monarch_limit: {
			max: 100,
			min: 1,
		},
	},
	monarch_feed_the_list_images: {
		monarch_limit: {
			max: 100,
			min: 1,
		},
	},
	monarch_feed_the_list_videos: {
		monarch_limit: {
			max: 100,
			min: 1,
		},
	},
	monarch_feed_community_calendar: {
		monarch_limit: {
			max: 100,
			min: 1,
		},
	},
	monarch_feed_creature_features: {
		monarch_limit: {
			max: 100,
			min: 1,
		},
	},
	monarch_feed_destinations: {
		monarch_limit: {
			max: 100,
			min: 1,
		},
	},
	monarch_feed_inspirations: {
		monarch_limit: {
			max: 100,
			min: 1,
		},
	},
	monarch_feed_pop_quiz_images: {
		monarch_limit: {
			max: 100,
			min: 1,
		},
	},
	monarch_feed_pop_quiz_videos: {
		monarch_limit: {
			max: 100,
			min: 1,
		},
	},
	monarch_feed_window_to_our_world: {
		monarch_limit: {
			max: 100,
			min: 1,
		},
	},
	monarch_feed_health_news_2_pak: {
		monarch_limit: {
			max: 100,
			min: 1,
		},
	},
	monarch_feed_healthy_bites_images: {
		monarch_limit: {
			max: 100,
			min: 1,
		},
	},
	monarch_feed_healthy_bites_videos: {
		monarch_limit: {
			max: 100,
			min: 1,
		},
	},
	monarch_feed_knowmore_living: {
		monarch_limit: {
			max: 100,
			min: 1,
		},
	},
	monarch_feed_local_health_conditions: {
		monarch_limit: {
			max: 100,
			min: 1,
		},
	},
	monarch_feed_missing_persons: {
		monarch_limit: {
			max: 100,
			min: 1,
		},
	},
	monarch_feed_fashion: {
		monarch_limit: {
			max: 100,
			min: 1,
		},
	},
	monarch_feed_community_events: {
		monarch_limit: {
			max: 100,
			min: 1,
		},
	},
	monarch_feed_ap_top_news_videos: {
		monarch_limit: {
			max: 100,
			min: 1,
		},
	},
	monarch_feed_digital_broadcaster_package: {
		monarch_limit: {
			max: 100,
			min: 1,
		},
	},
	monarch_feed_global_top_news_videos: {
		monarch_limit: {
			max: 100,
			min: 1,
		},
	},
	monarch_feed_news_in_pictures_3_pak: {
		monarch_limit: {
			max: 100,
			min: 1,
		},
	},
	monarch_feed_reuters_german_news_videos: {
		monarch_limit: {
			max: 100,
			min: 1,
		},
	},
	monarch_feed_reuters_national_news: {
		monarch_limit: {
			max: 100,
			min: 1,
		},
	},
	monarch_feed_reuters_odd_news: {
		monarch_limit: {
			max: 100,
			min: 1,
		},
	},
	monarch_feed_reuters_world_news: {
		monarch_limit: {
			max: 100,
			min: 1,
		},
	},
	monarch_feed_the_canadian_press: {
		monarch_limit: {
			max: 100,
			min: 1,
		},
	},
	monarch_feed_video_news_bites: {
		monarch_limit: {
			max: 100,
			min: 1,
		},
	},
	monarch_feed_action_sports: {
		monarch_limit: {
			max: 100,
			min: 1,
		},
	},
	monarch_feed_reuters_sports_news: {
		monarch_limit: {
			max: 100,
			min: 1,
		},
	},
	monarch_feed_sports_central: {
		monarch_limit: {
			max: 100,
			min: 1,
		},
	},
	monarch_feed_spectrum_weather: {
		monarch_limit: {
			max: 100,
			min: 1,
		},
	},
	monarch_feed_weather_forecast_videos: {
		monarch_limit: {
			max: 100,
			min: 1,
		},
	},
	monarch_feed_weather_graphics: {
		monarch_limit: {
			max: 100,
			min: 1,
		},
	},
};

export const dropdownSettings = {
	animated_scroller: [
		'scroll_type',
	],
	broadsign_feed: [
		'ad_provider',
	],
	brood: [
		'sort', 'transition_in', 'transition_out',
	],
	clock: [
		'time_format',
	],
	date_display: [
		'date_format',
	],
	dynamic_message: [
		'animation_type',
	],
	emergency_message: [
		'format', 'type',
	],
	entertainment: [
		'resolution',
	],
	info_box: [
		'reverse_order', 'text_align',
	],
	info_box_group: [
		'config',
	],
	listing_collection: [
		'vert_line_style',
	],
	listing_group: [
		'icon_child', 'icon_parent', 'vert_line_style',
	],
	mobile: [
		'mobile_theme',
	],
	news: [
		'animation_type',
	],
	navigation: [
		'nav_type',
	],
	navigation_button: [
		'icon_family', 'icon_type',
	],
	qr_code: [
		'format',
	],
	monarch: [
		'sort', 'transition_in', 'transition_out',
	],
	nova: [
		'sort', 'transition_in', 'transition_out', 'nova_size', 'nova_media_type', 'dmn_operator', 'mock_nova_scenario',
	],
	peacock: [
		'sort', 'transition_in', 'transition_out', 'peacock_size', 'peacock_media_type', 'dmn_operator',
	],
	pelican: [
		'sort', 'transition_in', 'transition_out',
	],
	stocks: [
		'format',
	],
	ts_logo: [
		'ts_logo_color',
	],
	text_list: [
		'decoration',
	],
	weather: [
		'day_config', 'item_format',
	],
	monarch_feed_financial_graphics: [
		 'monarch_theme', 'monarch_sort', 'monarch_size',
	],
	monarch_feed_reuters_business_news: [
		 'monarch_sort', 'monarch_size',
	],
	monarch_feed_reuters_business_news_videos: [
		 'monarch_size', 'monarch_sort',
	],
	monarch_feed_flight_info_arrivals: [
		 'monarch_sort', 'monarch_size',
	],
	monarch_feed_flight_info_departures: [
		 'monarch_sort', 'monarch_size',
	],
	monarch_feed_traffic_graphics: [
		 'monarch_sort', 'monarch_size',
	],
	monarch_feed_ap_celebrity_extra: [
		 'monarch_size', 'monarch_sort',
	],
	'monarch_feed_ap_entertainment_&_lifestyle_news_videos': [
		 'monarch_size', 'monarch_sort',
	],
	monarch_feed_ap_showbiz_and_newsminute_dailies: [
		 'monarch_sort', 'monarch_size',
	],
	monarch_feed_global_entertainment_news_videos: [
		 'monarch_size', 'monarch_sort',
	],
	monarch_feed_bright_spots_videos: [
		 'monarch_sort', 'monarch_size',
	],
	monarch_feed_good_news_videos: [
		 'monarch_sort', 'monarch_size',
	],
	monarch_feed_local_favorites: [
		'monarch_sort', 'monarch_size',
	],
	monarch_feed_reuters_entertainment_news: [
		'monarch_sort', 'monarch_size',
	],
	monarch_feed_the_list_images: [
		 'monarch_sort', 'monarch_size',
	],
	monarch_feed_the_list_videos: [
		 'monarch_sort', 'monarch_size',
	],
	monarch_feed_community_calendar: [
		 'monarch_theme', 'monarch_sort', 'monarch_size',
	],
	monarch_feed_creature_features: [
		 'monarch_size', 'monarch_sort',
	],
	monarch_feed_destinations: [
		 'monarch_size', 'monarch_sort',
	],
	monarch_feed_innovations: [
		 'monarch_size', 'monarch_sort',
	],
	monarch_feed_inspirations: [
		 'monarch_size', 'monarch_sort',
	],
	monarch_feed_pop_quiz_images: [
		 'monarch_sort', 'monarch_size',
	],
	monarch_feed_pop_quiz_videos: [
		 'monarch_sort', 'monarch_size',
	],
	monarch_feed_window_to_our_world: [
		 'monarch_size', 'monarch_sort',
	],
	monarch_feed_health_news_2_pak: [
		 'monarch_size', 'monarch_sort',
	],
	monarch_feed_healthy_bites_images: [
		 'monarch_size', 'monarch_sort',
	],
	monarch_feed_healthy_bites_videos: [
		 'monarch_sort', 'monarch_size',
	],
	monarch_feed_knowmore_living: [
		 'monarch_size', 'monarch_sort',
	],
	monarch_feed_local_health_conditions: [
		 'monarch_size', 'monarch_sort',
	],
	monarch_feed_missing_persons: [
		'monarch_size', 'monarch_sort',
	],
	monarch_feed_fashion: [
		'monarch_size', 'monarch_sort',
	],
	monarch_feed_community_events: [
		'monarch_size', 'monarch_sort',
	],
	monarch_feed_ap_top_news_videos: [
		 'monarch_size', 'monarch_sort',
	],
	monarch_feed_digital_broadcaster_package: [
		 'monarch_size', 'monarch_sort',
	],
	monarch_feed_global_top_news_videos: [
		 'monarch_size', 'monarch_sort',
	],
	monarch_feed_news_in_pictures_3_pak: [
		 'monarch_sort', 'monarch_size',
	],
	monarch_feed_reuters_german_news_videos: [
		 'monarch_size', 'monarch_sort',
	],
	monarch_feed_reuters_national_news: [
		 'monarch_sort', 'monarch_size',
	],
	monarch_feed_reuters_odd_news: [
		 'monarch_sort', 'monarch_size',
	],
	monarch_feed_reuters_world_news: [
		 'monarch_sort', 'monarch_size',
	],
	monarch_feed_the_canadian_press: [
		 'monarch_sort', 'monarch_size',
	],
	monarch_feed_video_news_bites: [
		 'monarch_size', 'monarch_sort',
	],
	monarch_feed_todays_top_tweets: [
		 'monarch_sort', 'monarch_size',
	],
	monarch_feed_action_sports: [
		 'monarch_sort', 'monarch_size',
	],
	monarch_feed_reuters_sports_news: [
		 'monarch_sort', 'monarch_size',
	],
	monarch_feed_sports_central: [
		 'monarch_sort', 'monarch_size',
	],
	monarch_feed_spectrum_weather: [
		 'monarch_sort', 'monarch_size',
	],
	monarch_feed_weather_forecast_videos: [
		 'monarch_size', 'monarch_sort',
	],
	monarch_feed_weather_graphics: [
		 'monarch_sort', 'monarch_size',
	],
	listings_scroller: [
		'scroll_buttons', 'default_keyboard',
	],
	raven_display: [
		'time_zone',
		'raven_time_format',
	],
	top_level_condor: [
		'font_header',
		'font_body',
	],
};

export const fontFamilyOptions = [
	{
		label:   'TouchSource Fonts',
		options: [
			{
				value: 'default',
				label: 'Default',
			},
			{
				value: 'AGaramondPro-Bold, Georgia, serif',
				label: 'Adobe Garamond Pro Bold',
			},
			{
				value: 'AGaramondPro-Regular, Georgia, serif',
				label: 'Adobe Garamond Pro Regular',
			},
			{
				value: 'AGaramondPro-Semibold, Georgia, serif',
				label: 'Adobe Garamond Pro Semibold',
			},
			{
				value: 'Amble-Bold, sans-serif',
				label: 'Amble Bold',
			},
			{
				value: 'Amble-Light, sans-serif',
				label: 'Amble Light',
			},
			{
				value: 'Amble-Regular, sans-serif',
				label: 'Amble Regular',
			},
			{
				value: 'Avenir-Book, sans-serif',
				label: 'Avenir Book',
			},
			{
				value: 'Avenir-Heavy, sans-serif',
				label: 'Avenir Heavy',
			},
			{
				value: 'Avenir-Light, sans-serif',
				label: 'Avenir Light',
			},
			{
				value: 'bahnschrift, sans-serif',
				label: 'Bahnschrift',
			},
			{
				value: 'Bodoni72-Bold, serif',
				label: 'Bodoni 72 Bold',
			},
			{
				value: 'Boton-Bold, sans-serif',
				label: 'Boton Bold',
			},
			{
				value: 'Brandon-Regular, sans-serif',
				label: 'Brandon Regular',
			},
			{
				value: 'Brandon-Bold, sans-serif',
				label: 'Brandon Bold',
			},
			{
				value: 'BrittanicBold, serif',
				label: 'Brittanic Bold',
			},
			{
				value: 'Domine-Regular, serif',
				label: 'Domine Regular',
			},
			{
				value: 'DroidSerif-Bold-webfont, serif',
				label: 'Droid Serif Bold',
			},
			{
				value: 'DroidSerif-Regular, serif',
				label: 'Droid Serif Regular',
			},
			{
				value: 'Fanwood-Regular, serif',
				label: 'Fanwood Regular',
			},
			{
				value: 'Gotham-Bold, sans-serif',
				label: 'Gotham Bold',
			},
			{
				value: 'GothamBook, sans-serif',
				label: 'Gotham Book',
			},
			{
				value: 'HelveticaNeueLTStd-Condensed, sans-serif',
				label: 'Helvetica Neue Condensed',
			},
			{
				value: 'HelveticaNeueLTStd-Heavy, sans-serif',
				label: 'Helvetica Neue Heavy',
			},
			{
				value: 'HelveticaNeueLTStd-Light, sans-serif',
				label: 'Helvetica Neue Light',
			},
			{
				value: 'Lato-Bold, sans-serif',
				label: 'Lato Bold',
			},
			{
				value: 'Lato-Regular, sans-serif',
				label: 'Lato Regular',
			},
			{
				value: 'Lato-Thin, sans-serif',
				label: 'Lato Thin',
			},
			{
				value: 'Montserrat-Bold, sans-serif',
				label: 'Montserrat Bold',
			},
			{
				value: 'Montserrat-Light, sans-serif',
				label: 'Montserrat Light',
			},
			{
				value: 'Montserrat-Regular, sans-serif',
				label: 'Montserrat Regular',
			},
			{
				value: 'MrsEavesRoman-Regular, serif',
				label: 'Mrs Eaves Roman',
			},
			{
				value: 'NotoSans, sans-serif',
				label: 'Noto Sans',
			},
			{
				value: 'NotoSerif, serif',
				label: 'Noto Serif',
			},
			{
				value: 'open-sans-v17-latin-300, sans-serif',
				label: 'Open Sans Light',
			},
			{
				value: 'open-sans-v17-latin-300italic, sans-serif',
				label: 'Open Sans Light Italic',
			},
			{
				value: 'open-sans-v17-latin-600, sans-serif',
				label: 'Open Sans SemiBold',
			},
			{
				value: 'open-sans-v17-latin-600italic, sans-serif',
				label: 'Open Sans SemiBold Italic',
			},
			{
				value: 'open-sans-v17-latin-700, sans-serif',
				label: 'Open Sans Bold',
			},
			{
				value: 'open-sans-v17-latin-700italic, sans-serif',
				label: 'Open Sans Bold Italic',
			},
			{
				value: 'open-sans-v17-latin-800, sans-serif',
				label: 'Open Sans ExtraBold',
			},
			{
				value: 'open-sans-v17-latin-800italic, sans-serif',
				label: 'Open Sans ExtraBold Italic',
			},
			{
				value: 'open-sans-v17-latin-italic, sans-serif',
				label: 'Open Sans Italic',
			},
			{
				value: 'open-sans-v17-latin-regular, sans-serif',
				label: 'Open Sans Regular',
			},
			{
				value: 'Poppins-Regular, sans-serif',
				label: 'Poppins Regular',
			},
			{
				value: 'raleway-black-webfont, sans-serif',
				label: 'Raleway Black',
			},
			{
				value: 'raleway-blackitalic-webfont, sans-serif',
				label: 'Raleway Black Italic',
			},
			{
				value: 'raleway-bold-webfont, sans-serif',
				label: 'Raleway Bold',
			},
			{
				value: 'raleway-bolditalic-webfont, sans-serif',
				label: 'Raleway Bold Italic',
			},
			{
				value: 'raleway-extrabold-webfont, sans-serif',
				label: 'Raleway ExtraBold',
			},
			{
				value: 'raleway-extrabolditalic-webfont, sans-serif',
				label: 'Raleway ExtraBold Italic',
			},
			{
				value: 'raleway-extralight-webfont, sans-serif',
				label: 'Raleway ExtraLight',
			},
			{
				value: 'raleway-extralightitalic-webfont, sans-serif',
				label: 'Raleway ExtraLight Italic',
			},
			{
				value: 'raleway-italic-webfont, sans-serif',
				label: 'Raleway Italic',
			},
			{
				value: 'raleway-light-webfont, sans-serif',
				label: 'Raleway Light',
			},
			{
				value: 'raleway-lightitalic-webfont, sans-serif',
				label: 'Raleway Light Italic',
			},
			{
				value: 'raleway-medium-webfont, sans-serif',
				label: 'Raleway Medium',
			},
			{
				value: 'raleway-mediumitalic-webfont, sans-serif',
				label: 'Raleway Medium Italic',
			},
			{
				value: 'raleway-regular-webfont, sans-serif',
				label: 'Raleway Regular',
			},
			{
				value: 'raleway-semibold-webfont, sans-serif',
				label: 'Raleway SemiBold',
			},
			{
				value: 'raleway-semibolditalic-webfont, sans-serif',
				label: 'Raleway SemiBold Italic',
			},
			{
				value: 'raleway-thin-webfont, sans-serif',
				label: 'Raleway Thin',
			},
			{
				value: 'raleway-thinitalic-webfont, sans-serif',
				label: 'Raleway Thin Italic',
			},
			{
				value: 'raleway-v14-latin-100, sans-serif',
				label: 'Raleway v14 Thin',
			},
			{
				value: 'raleway-v14-latin-300, sans-serif',
				label: 'Raleway v14 Light',
			},
			{
				value: 'raleway-v14-latin-700, sans-serif',
				label: 'Raleway v14 Bold',
			},
			{
				value: 'raleway-v14-latin-900, sans-serif',
				label: 'Raleway v14 Black',
			},
			{
				value: 'raleway-v14-latin-regular, sans-serif',
				label: 'Raleway v14 Regular',
			},
			{
				value: 'rawline-100, sans-serif',
				label: 'Rawline Thin',
			},
			{
				value: 'rawline-300, sans-serif',
				label: 'Rawline Light',
			},
			{
				value: 'rawline-400, sans-serif',
				label: 'Rawline Regular',
			},
			{
				value: 'rawline-700, sans-serif',
				label: 'Rawline Bold',
			},
			{
				value: 'rawline-900, sans-serif',
				label: 'Rawline Black',
			},
			{
				value: 'Roboto-Black, sans-serif',
				label: 'Roboto Black',
			},
			{
				value: 'Roboto-Bold, sans-serif',
				label: 'Roboto Bold',
			},
			{
				value: 'Roboto-Light, sans-serif',
				label: 'Roboto Light',
			},
			{
				value: 'Roboto-Regular, sans-serif',
				label: 'Roboto Regular',
			},
			{
				value: 'Univers-Bold, sans-serif',
				label: 'Univers Bold',
			},
			{
				value: 'Univers-Condensed, sans-serif',
				label: 'Univers Condensed',
			},
			{
				value: 'Univers-Extended, sans-serif',
				label: 'Univers Extended',
			},
			{
				value: 'Univers-Light, sans-serif',
				label: 'Univers Light',
			},
			{
				value: 'Univers-Regular, sans-serif',
				label: 'Univers Regular',
			},
		],
	},
	{
		label:   'Windows Fonts',
		options: [
			{
				value: 'Arial, sans-serif',
				label: 'Arial',
			},
			{
				value: 'Courier New, serif',
				label: 'Courier New',
			},
			{
				value: 'Impact, sans-serif',
				label: 'Impact',
			},
			{
				value: 'Georgia, serif',
				label: 'Georgia',
			},
			{
				value: 'Tahoma, sans-serif',
				label: 'Tahoma',
			},
			{
				value: 'Trebuchet MS, sans-serif',
				label: 'Trebuchet MS',
			},
			{
				value: 'Times New Roman, serif',
				label: 'Times New Roman',
			},
			{
				value: 'Verdana, sans-serif',
				label: 'Verdana',
			},
		],
	},
	{
		label:   'Linux Fonts',
		options: [
			{
				value: 'Liberation Mono, sans-serif',
				label: 'Liberation Mono',
			},
			{
				value: 'Liberation Sans, sans-serif',
				label: 'Liberation Sans',
			},
			{
				value: 'Liberation Serif, serif',
				label: 'Liberation Serif',
			},
		],
	},
];


export const dropdownValues = {
	top_level_condor: {
		font_header: fontFamilyOptions,
		font_body:   fontFamilyOptions,
	},
	animated_scroller: {
		scroll_type: [
			{
				value: 0,
				label: 'Vertical',
			},
			{
				value: 1,
				label: 'Horizontal',
			},
		],
	},
	broadsign_feed: {
		ad_provider: [
			{
				value: 'pearl_media',
				label: 'Pearl Media',
			},
			{
				value: 'taubman',
				label: 'Taubman',
			},
		],
	},
	brood: {
		sort: [
			{
				value: 'sequential',
				label: 'Sequential',
			},
			{
				value: 'random',
				label: 'Random',
			},
		],
		transition_in: [
			{
				value: 'fadeIn',
				label: 'Fade In',
			},
			{
				value: 'none',
				label: 'None',
			},
		],
		transition_out: [
			{
				value: 'fadeOut',
				label: 'Fade Out',
			},
			{
				value: 'none',
				label: 'None',
			},
		],
	},
	clock: {
		time_format: [
			{
				value: '12_hour',
				label: 'Standard',
			},
			{
				value: 'military',
				label: 'Military',
			},
		],
	},
	date_display: {
		date_format: [
			{
				value: 1,
				label: 'Monday, February 24',
			},
			{
				value: 2,
				label: 'February 24',
			},
			{
				value: 3,
				label: 'Mon, Feb 24',
			},
			{
				value: 4,
				label: 'Feb 24',
			},
			{
				value: 5,
				label: '2/24',
			},
		],
	},
	dynamic_message: {
		animation_type: [
			{
				value: 0,
				label: 'None',
			},
			{
				value: 1,
				label: 'Fade',
			},
			{
				value: 2,
				label: 'Roll',
			},
			{
				value: 3,
				label: 'Slide',
			},
			{
				value: 4,
				label: 'Reveal',
			},
		],
	},
	emergency_message: {
		format: [
			{
				value: 'sidebar',
				label: 'Sidebar',
			},
			{
				value: 'simple',
				label: 'Simple',
			},
			{
				value: 'border',
				label: 'Border',
			},
		],
		type: [
			{
				value: 'emergency',
				label: 'Emergency',
			},
			{
				value: 'urgent',
				label: 'Urgent',
			},
			{
				value: 'warning',
				label: 'Warning',
			},
		],
	},
	entertainment: {
		resolution: [
			{
				value: '3840x2160',
				label: '3840x2160',
			},
			{
				value: '2160x3840',
				label: '2160x3840',
			},
			{
				value: '1920x1080',
				label: '1920x1080',
			},
			{
				value: '1080x1920',
				label: '1080x1920',
			},
			{
				value: '1280x720',
				label: '1280x720',
			},
			{
				value: '720x1280',
				label: '720x1280',
			},
		],
	},
	info_box: {
		reverse_order: [
			{
				value: 0,
				label: 'False',
			},
			{
				value: 1,
				label: 'True',
			},
		],
		text_align: [
			{
				value: 1,
				label: 'Left',
			},
			{
				value: 2,
				label: 'Center',
			},
			{
				value: 3,
				label: 'Right',
			},
		],
	},
	info_box_group: {
		config: [
			{
				value: 0,
				label: 'Horizontal',
			},
			{
				value: 1,
				label: 'Vertical',
			},
		],
	},
	listing_collection: {
		vert_line_style: [
			{
				value: 0,
				label: 'Gradient',
			},
			{
				value: 1,
				label: 'Solid',
			},
			{
				value: 2,
				label: 'Broken',
			},
		],
	},
	listing_group: {
		icon_child: [
			{
				value: 0,
				label: 'None',
			},
			{
				value: 1,
				label: 'fa-circle',
			},
			{
				value: 2,
				label: 'fa-circle',
			},
			{
				value: 3,
				label: 'fa-square',
			},
			{
				value: 4,
				label: 'fa-square',
			},
			{
				value: 5,
				label: 'fa-user',
			},
			{
				value: 6,
				label: 'user-friends',
			},
			{
				value: 7,
				label: 'fa-user',
			},
			{
				value: 8,
				label: 'user-circle',
			},
			{
				value: 9,
				label: 'user-circle',
			},
			{
				value: 10,
				label: 'fa-building',
			},
			{
				value: 11,
				label: 'fa-building',
			},
		],
		icon_parent: [
			{
				value: 0,
				label: 'None',
			},
			{
				value: 1,
				label: 'fa-circle',
			},
			{
				value: 2,
				label: 'fa-circle',
			},
			{
				value: 3,
				label: 'fa-square',
			},
			{
				value: 4,
				label: 'fa-square',
			},
			{
				value: 5,
				label: 'fa-user',
			},
			{
				value: 6,
				label: 'user-friends',
			},
			{
				value: 7,
				label: 'fa-user',
			},
			{
				value: 8,
				label: 'user-circle',
			},
			{
				value: 9,
				label: 'user-circle',
			},
			{
				value: 10,
				label: 'fa-building',
			},
			{
				value: 11,
				label: 'fa-building',
			},
		],
		vert_line_style: [
			{
				value: 0,
				label: 'Gradient',
			},
			{
				value: 1,
				label: 'Solid',
			},
			{
				value: 2,
				label: 'Broken',
			},
		],
	},
	mobile: {
		// Values map to the .c0–.c15 theme classes in condor_mobile styles/globals.css
		mobile_theme: [
			{
				value: 0,
				label: '0 - Dark with Teal',
			},
			{
				value: 1,
				label: '1 - Dark with Blue',
			},
			{
				value: 2,
				label: '2 - Dark with Yellow',
			},
			{
				value: 3,
				label: '3 - Dark with Green',
			},
			{
				value: 4,
				label: '4 - Dark with Orange',
			},
			{
				value: 5,
				label: '5 - Black',
			},
			{
				value: 6,
				label: '6 - White',
			},
			{
				value: 7,
				label: '7 - White with Purple Accent',
			},
			{
				value: 8,
				label: '8 - White with Red Accent',
			},
			{
				value: 9,
				label: '9 - White with Blue Accent',
			},
			{
				value: 10,
				label: '10 - Blue/Teal Gradients',
			},
			{
				value: 11,
				label: '11 - Orange/Yellow Gradients',
			},
			{
				value: 12,
				label: '12 - Purple/Pink Gradients',
			},
			{
				value: 13,
				label: '13 - Blue/Gray Gradients',
			},
			{
				value: 14,
				label: '14 - Black/Gray Gradients',
			},
			{
				value: 15,
				label: '15 - White (Web Colors)',
			},
		],
	},
	news: {
		animation_type: [
			{
				value: 1,
				label: 'Pop',
			},
			{
				value: 2,
				label: 'Fade',
			},
			{
				value: 3,
				label: 'Roll',
			},
			{
				value: 4,
				label: 'Slide',
			},
		],
	},
	navigation: {
		nav_type: [
			{
				value: 'navConstant',
				label: 'Constant (always visible)',
			},
			{
				value: 'navMain',
				label: 'Main (shows/hides)',
			},
			{
				value: 'navIdle',
				label: 'Idle (visible during screensaver)',
			},
			{
				value: 'ADA',
				label: 'ADA (accessibility)',
			},
		],
	},

	navigation_button: {
		icon_family: [
			{
				value:     0,
				label:     'Default',
				icon_type: [
					{
						value: 0,
						label: 'None',
					},
					{
						value: 1,
						label: 'Announcements',
						icon:  'https://ts-condor-assets.s3.amazonaws.com/images/icons/nav/default/announcements.svg',
					},
					{
						value: 2,
						label: 'Amenities Area',
						icon:  'https://ts-condor-assets.s3.amazonaws.com/images/icons/nav/default/amenitiesArea.svg',
					},
					{
						value: 3,
						label: 'Amenities Building',
						icon:  'https://ts-condor-assets.s3.amazonaws.com/images/icons/nav/default/amenitiesBldg.svg',
					},
					{
						value: 4,
						label: 'Document',
						icon:  'https://ts-condor-assets.s3.amazonaws.com/images/icons/nav/default/document.svg',
					},
					{
						value: 5,
						label: 'Floor Plan',
						icon:  'https://ts-condor-assets.s3.amazonaws.com/images/icons/nav/default/floorplan.svg',
					},
					{
						value: 6,
						label: 'Home',
						icon:  'https://ts-condor-assets.s3.amazonaws.com/images/icons/nav/default/home.svg',
					},
					{
						value: 7,
						label: 'Individuals',
						icon:  'https://ts-condor-assets.s3.amazonaws.com/images/icons/nav/default/individuals.svg',
					},
					{
						value: 8,
						label: 'Info',
						icon:  'https://ts-condor-assets.s3.amazonaws.com/images/icons/nav/default/info.svg',
					},
					{
						value: 9,
						label: 'Info 2',
						icon:  'https://ts-condor-assets.s3.amazonaws.com/images/icons/nav/default/info2.svg',
					},
					{
						value: 10,
						label: 'Search',
						icon:  'https://ts-condor-assets.s3.amazonaws.com/images/icons/nav/default/search.svg',
					},
					{
						value: 11,
						label: 'Space Available',
						icon:  'https://ts-condor-assets.s3.amazonaws.com/images/icons/nav/default/spaceAvailable.svg',
					},
					{
						value: 12,
						label: 'Tenants',
						icon:  'https://ts-condor-assets.s3.amazonaws.com/images/icons/nav/default/tenants.svg',
					},
					{
						value: 13,
						label: 'Traffic',
						icon:  'https://ts-condor-assets.s3.amazonaws.com/images/icons/nav/default/traffic.svg',
					},
					{
						value: 14,
						label: 'Transit',
						icon:  'https://ts-condor-assets.s3.amazonaws.com/images/icons/nav/default/transit.svg',
					},
					{
						value: 15,
						label: 'URL',
						icon:  'https://ts-condor-assets.s3.amazonaws.com/images/icons/nav/default/url.svg',
					},
					{
						value: 16,
						label: 'Video',
						icon:  'https://ts-condor-assets.s3.amazonaws.com/images/icons/nav/default/video.svg',
					},
					{
						value: 25,
						label: 'Airplane',
						icon:  'https://ts-condor-assets.s3.amazonaws.com/images/icons/nav/default/airplane.svg',
					},
					{
						value: 26,
						label: 'Anchor',
						icon:  'https://ts-condor-assets.s3.amazonaws.com/images/icons/nav/default/anchor.svg',
					},
					{
						value: 27,
						label: 'Announcements 2',
						icon:  'https://ts-condor-assets.s3.amazonaws.com/images/icons/nav/default/announcements2.svg',
					},
					{
						value: 28,
						label: 'Brochure',
						icon:  'https://ts-condor-assets.s3.amazonaws.com/images/icons/nav/default/brochure.svg',
					},
					{
						value: 29,
						label: 'Conference Room',
						icon:  'https://ts-condor-assets.s3.amazonaws.com/images/icons/nav/default/conferenceRoom.svg',
					},
					{
						value: 30,
						label: 'Directory Hierarchy',
						icon:  'https://ts-condor-assets.s3.amazonaws.com/images/icons/nav/default/directoryHierarchy.svg',
					},
					{
						value: 31,
						label: 'Directory Person',
						icon:  'https://ts-condor-assets.s3.amazonaws.com/images/icons/nav/default/directoryPerson.svg',
					},
					{
						value: 32,
						label: 'Doctor',
						icon:  'https://ts-condor-assets.s3.amazonaws.com/images/icons/nav/default/doctor.svg',
					},
					{
						value: 33,
						label: 'Events Calendar',
						icon:  'https://ts-condor-assets.s3.amazonaws.com/images/icons/nav/default/eventsCalendar.svg',
					},
					{
						value: 34,
						label: 'FAQ Question Mark',
						icon:  'https://ts-condor-assets.s3.amazonaws.com/images/icons/nav/default/FAQQuestionMark.svg',
					},
					{
						value: 35,
						label: 'Floor Plan 3',
						icon:  'https://ts-condor-assets.s3.amazonaws.com/images/icons/nav/default/floorplan3.svg',
					},
					{
						value: 36,
						label: 'Gym',
						icon:  'https://ts-condor-assets.s3.amazonaws.com/images/icons/nav/default/gym.svg',
					},
					{
						value: 37,
						label: 'Home Plate',
						icon:  'https://ts-condor-assets.s3.amazonaws.com/images/icons/nav/default/homePlate.svg',
					},
					{
						value: 38,
						label: 'Hospital Cross',
						icon:  'https://ts-condor-assets.s3.amazonaws.com/images/icons/nav/default/hospitalCross.svg',
					},
					{
						value: 39,
						label: 'Info 3',
						icon:  'https://ts-condor-assets.s3.amazonaws.com/images/icons/nav/default/info3.svg',
					},
					{
						value: 40,
						label: 'Light Bulb',
						icon:  'https://ts-condor-assets.s3.amazonaws.com/images/icons/nav/default/lightBulb.svg',
					},
					{
						value: 41,
						label: 'Map Marker',
						icon:  'https://ts-condor-assets.s3.amazonaws.com/images/icons/nav/default/mapMarker.svg',
					},
					{
						value: 42,
						label: 'Restaurant',
						icon:  'https://ts-condor-assets.s3.amazonaws.com/images/icons/nav/default/restaurant.svg',
					},
					{
						value: 43,
						label: 'Shield',
						icon:  'https://ts-condor-assets.s3.amazonaws.com/images/icons/nav/default/shield.svg',
					},
					{
						value: 44,
						label: 'Url Globe 2',
						icon:  'https://ts-condor-assets.s3.amazonaws.com/images/icons/nav/default/urlGlobe2.svg',
					},
					{
						value: 50,
						label: 'Award',
						icon:  'https://ts-condor-assets.s3.amazonaws.com/images/icons/nav/default/award.svg',
					},
					{
						value: 51,
						label: 'Trophy',
						icon:  'https://ts-condor-assets.s3.amazonaws.com/images/icons/nav/default/trophy.svg',
					},
				].sort((a, b) => {
					// setting None as the first option always
					if (a.label === 'None') {
						return -1;
					}
					if (b.label === 'None') {
						return 1;
					}
					if (a.label > b.label) {
						return 1;
					}
					return -1;
				}),
			},
			{
				value:     1,
				label:     'Retail',
				icon_type: [
					{
						value: 0,
						label: 'None',
					},
					{
						value: 17,
						label: 'Dining',
						icon:  'https://ts-condor-assets.s3.amazonaws.com/images/icons/nav/retail/dining.svg',
					},
					{
						value: 18,
						label: 'Calendar',
						icon:  'https://ts-condor-assets.s3.amazonaws.com/images/icons/nav/retail/eventsCal.svg',
					},
					{
						value: 19,
						label: 'Fun',
						icon:  'https://ts-condor-assets.s3.amazonaws.com/images/icons/nav/retail/fun.svg',
					},
					{
						value: 20,
						label: 'Home',
						icon:  'https://ts-condor-assets.s3.amazonaws.com/images/icons/nav/retail/homeOutline.svg',
					},
					{
						value: 21,
						label: 'Map',
						icon:  'https://ts-condor-assets.s3.amazonaws.com/images/icons/nav/retail/mapOutline.svg',
					},
					{
						value: 22,
						label: 'Services',
						icon:  'https://ts-condor-assets.s3.amazonaws.com/images/icons/nav/retail/services.svg',
					},
					{
						value: 23,
						label: 'Shopping',
						icon:  'https://ts-condor-assets.s3.amazonaws.com/images/icons/nav/retail/shopping.svg',
					},
					{
						value: 24,
						label: 'Search',
						icon:  'https://ts-condor-assets.s3.amazonaws.com/images/icons/nav/retail/searchAll.svg',
					},
				].sort((a, b) => {
					// setting None as the first option always
					if (a.label === 'None') {
						return -1;
					}
					if (b.label === 'None') {
						return 1;
					}
					if (a.label > b.label) {
						return 1;
					}
					return -1;
				}),
			},
			{
				value:     2,
				label:     'Custom',
				icon_type: [
					{
						value: 0,
						label: 'None',
					},
					{
						value: 45,
						label: 'Dine',
						icon:  'https://ts-condor-assets.s3.amazonaws.com/images/icons/nav/custom/dine.svg',
					},
					{
						value: 46,
						label: 'Events',
						icon:  'https://ts-condor-assets.s3.amazonaws.com/images/icons/nav/custom/events.svg',
					},
					{
						value: 47,
						label: 'Live',
						icon:  'https://ts-condor-assets.s3.amazonaws.com/images/icons/nav/custom/live.svg',
					},
					{
						value: 48,
						label: 'Shopping',
						icon:  'https://ts-condor-assets.s3.amazonaws.com/images/icons/nav/custom/shopping.svg',
					},
					{
						value: 49,
						label: 'Visit',
						icon:  'https://ts-condor-assets.s3.amazonaws.com/images/icons/nav/custom/visit.svg',
					},
				].sort((a, b) => {
					// setting None as the first option always
					if (a.label === 'None') {
						return -1;
					}
					if (b.label === 'None') {
						return 1;
					}
					if (a.label > b.label) {
						return 1;
					}
					return -1;
				}),
			},
			{
				value: 3,
				label: 'Upload Image',
				icon_type: [
					{
						value: 0,
						label: 'Uploaded Image',
					},
				],
			},
		],
	},
	qr_code: {
		format: [
			{
				value: 'textTop',
				label: 'Text Top',
			},
			{
				value: 'textRight',
				label: 'Text Right',
			},
			{
				value: 'textBottom',
				label: 'Text Bottom',
			},
			{
				value: 'textLeft',
				label: 'Text Left',
			},
		],
	},
	monarch: {
		sort: [
			{
				value: 'random',
				label: 'Random',
			},
			{
				value: 'sequential',
				label: 'Sequential',
			},
		],
		transition_in: [
			{
				value: 'fadeIn',
				label: 'Fade In',
			},
			{
				value: 'fadeOut',
				label: 'Fade Out',
			},
		],
		transition_out: [
			{
				value: 'fadeIn',
				label: 'Fade In',
			},
			{
				value: 'fadeOut',
				label: 'Fade Out',
			},
		],
	},
	nova: {
		sort: [
			{
				value: 'random',
				label: 'Random',
			},
			{
				value: 'sequential',
				label: 'Sequential',
			},
		],
		transition_in: [
			{
				value: 'fadeIn',
				label: 'Fade In',
			},
			{
				value: 'fadeOut',
				label: 'Fade Out',
			},
			{
				value: 'none',
				label: 'None',
			},
		],
		transition_out: [
			{
				value: 'fadeIn',
				label: 'Fade In',
			},
			{
				value: 'fadeOut',
				label: 'Fade Out',
			},
			{
				value: 'none',
				label: 'None',
			},
		],
		nova_size: [
			{
				value: '1920x1080',
				label: '1920x1080',
			},
			{
				value: '1080x1920',
				label: '1080x1920',
			},
			{
				value: '1280x960',
				label: '1280x960',
			},
			{
				value: '1400x400',
				label: '1400x400',
			},
			{
				value: '840x400',
				label: '840x400',
			},
		],
		nova_media_type: [
			{
				value: 'image/jpeg,image/png,video/mp4',
				label: 'Image and Video',
			},
			{
				value: 'image/jpeg,image/png',
				label: 'Image',
			},
			{
				value: 'video/mp4',
				label: 'Video',
			},
		],
		dmn_operator: [
			{
				value: 'screenverse',
				label: 'Screenverse',
			},
		],
		// mock_nova_scenario is a fake (non-schema) setting — see
		// TemplateSkeleton.js getMockNovaEnabledForAccount()/MOCK_NOVA_SETTING_CATEGORY.
		// Values are the raw JSON string Nova.js/mock_nova.go expect, keeping the
		// dropdown a thin UI over the same wire format (no client/bronco changes).
		mock_nova_scenario: [
			{
				value: '{"mode":"full"}',
				label: 'Full (always full, never zero)',
			},
			{
				value: '{"mode":"no_ads"}',
				label: 'No Ads',
			},
			{
				value: '{"mode":"partial"}',
				label: 'Partial',
			},
			{
				value: '{"mode":"network_error"}',
				label: 'Network Error',
			},
			{
				value: '{"mode":"random"}',
				label: 'Random',
			},
		],
	},
	peacock: {
		sort: [
			{
				value: 'random',
				label: 'Random',
			},
			{
				value: 'sequential',
				label: 'Sequential',
			},
		],
		transition_in: [
			{
				value: 'fadeIn',
				label: 'Fade In',
			},
			{
				value: 'fadeOut',
				label: 'Fade Out',
			},
			{
				value: 'none',
				label: 'None',
			},
		],
		transition_out: [
			{
				value: 'fadeIn',
				label: 'Fade In',
			},
			{
				value: 'fadeOut',
				label: 'Fade Out',
			},
			{
				value: 'none',
				label: 'None',
			},
		],
		peacock_size: [
			{
				value: '1920x1080',
				label: '1920x1080',
			},
			{
				value: '1080x1920',
				label: '1080x1920',
			},
			{
				value: '1280x960',
				label: '1280x960',
			},
			{
				value: '1400x400',
				label: '1400x400',
			},
			{
				value: '840x400',
				label: '840x400',
			},
		],
		peacock_media_type: [
			{
				value: 'image/jpeg,image/png,video/mp4',
				label: 'Image and Video',
			},
			{
				value: 'image/jpeg,image/png',
				label: 'Image',
			},
			{
				value: 'video/mp4',
				label: 'Video',
			},
		],
		dmn_operator: [
			{
				value: 'corner_media',
				label: 'Corner Media',
			},
			{
				value: 'liquid_outdoor',
				label: 'Liquid Outdoor',
			},
			{
				value: 'mg_malls',
				label: 'MG Malls',
			},
			{
				value: 'screenverse',
				label: 'Screenverse',
			},
		],
	},
	pelican: {
		sort: [
			{
				value: 'random',
				label: 'Random',
			},
			{
				value: 'sequential',
				label: 'Sequential',
			},
		],
		transition_in: [
			{
				value: 'fadeIn',
				label: 'Fade In',
			},
			{
				value: 'fadeOut',
				label: 'Fade Out',
			},
			{
				value: 'none',
				label: 'None',
			},
		],
		transition_out: [
			{
				value: 'fadeIn',
				label: 'Fade In',
			},
			{
				value: 'fadeOut',
				label: 'Fade Out',
			},
			{
				value: 'none',
				label: 'None',
			},
		],
	},
	stocks: {
		format: [
			{
				value: 'animated',
				label: 'Animated',
			},
			{
				value: 'horizontal1',
				label: 'Horizontal 1',
			},
			{
				value: 'horizontal2',
				label: 'Horizontal 2',
			},
			{
				value: 'vertical1',
				label: 'Vertical 1',
			},
			{
				value: 'vertical2',
				label: 'Vertical 2',
			},
			{
				value: 'vertical3',
				label: 'Vertical 3',
			},
		],
	},
	ts_logo: {
		ts_logo_color: [
			{
				value: 'White',
				label: 'White',
			},
			{
				value: 'WhiteBlue',
				label: 'White & Blue',
			},
			{
				value: 'Black',
				label: 'Black',
			},
			{
				value: 'BlackBlue',
				label: 'Black & Blue',
			},
		],
	},
	text_list: {
		decoration: [
			{
				value: 'disc',
				label: 'Disc',
			},
			{
				value: 'circle',
				label: 'Circle',
			},
			{
				value: 'none',
				label: 'None',
			},
			{
				value: 'square',
				label: 'Square',
			},
		],
	},
	weather: {
		day_config: [
			{
				value: 0,
				label: 'Standard',
			},
			{
				value: 1,
				label: 'Line Separated',
			},
			{
				value: 2,
				label: 'Colored Squares',
			},
		],
		item_format: [
			{
				value: 'format1',
				label: 'Format 1',
			},
			{
				value: 'format2',
				label: 'Format 2',
			},
		],
	},
	monarch_feed_financial_graphics: {
		monarch_theme: [
			{
				label: 'Money-Green',
				value: 'money-green',
			}, {
				label: 'Metro-Smooth',
				value: 'metro-smooth',
			}, {
				label: 'Metro-Dark',
				value: 'metro-dark',
			}, {
				label: 'Metro-Light',
				value: 'metro-light',
			},
		],
		monarch_sort: [
			{
				label: 'Sequential',
				value: 'sequential',
			}, {
				label: 'Random',
				value: 'random',
			},
		],
		monarch_size: [
			{
				label: '16x9',
				value: '1920x1080',
			}, {
				label: '9x16',
				value: '1080x1920',
			}, {
				label: '4x3',
				value: '1024x768',
			},
		],
	},
	monarch_feed_reuters_business_news: {
		monarch_sort: [
			{
				label: 'Sequential',
				value: 'sequential',
			}, {
				label: 'Random',
				value: 'random',
			},
		],
		monarch_size: [
			{
				label: '16x9',
				value: '1920x1080',
			}, {
				label: '9x16',
				value: '1080x1920',
			}, {
				label: '4x3',
				value: '1024x768',
			},
		],
	},
	monarch_feed_reuters_business_news_videos: {
		monarch_size: [
			{
				label: '1280x720',
				value: '1280x720',
			},
		],
		monarch_sort: [
			{
				label: 'Sequential',
				value: 'sequential',
			}, {
				label: 'Random',
				value: 'random',
			},
		],
	},
	monarch_feed_flight_info_arrivals: {
		monarch_sort: [
			{
				label: 'Sequential',
				value: 'sequential',
			}, {
				label: 'Random',
				value: 'random',
			},
		],
		monarch_size: [
			{
				label: '16x9',
				value: '1920x1080',
			}, {
				label: '9x16',
				value: '1080x1920',
			}, {
				label: '4x3',
				value: '1024x768',
			},
		],
	},
	monarch_feed_flight_info_departures: {
		monarch_sort: [
			{
				label: 'Sequential',
				value: 'sequential',
			}, {
				label: 'Random',
				value: 'random',
			},
		],
		monarch_size: [
			{
				label: '16x9',
				value: '1920x1080',
			}, {
				label: '9x16',
				value: '1080x1920',
			}, {
				label: '4x3',
				value: '1024x768',
			},
		],
	},
	monarch_feed_traffic_graphics: {
		monarch_sort: [
			{
				label: 'Sequential',
				value: 'sequential',
			}, {
				label: 'Random',
				value: 'random',
			},
		],
		monarch_size: [
			{
				label: '16x9',
				value: '1920x1080',
			}, {
				label: '9x16',
				value: '1080x1920',
			}, {
				label: '4x3',
				value: '1024x768',
			},
		],
	},
	monarch_feed_ap_celebrity_extra: {
		monarch_size: [
			{
				label: '853x480',
				value: '853x480',
			},
		],
		monarch_sort: [
			{
				label: 'Sequential',
				value: 'sequential',
			}, {
				label: 'Random',
				value: 'random',
			},
		],
	},
	'monarch_feed_ap_entertainment_&_lifestyle_news_videos': {
		monarch_size: [
			{
				label: '853x480',
				value: '853x480',
			},
		],
		monarch_sort: [
			{
				label: 'Sequential',
				value: 'sequential',
			}, {
				label: 'Random',
				value: 'random',
			},
		],
	},
	monarch_feed_ap_showbiz_and_newsminute_dailies: {
		monarch_sort: [
			{
				label: 'Sequential',
				value: 'sequential',
			}, {
				label: 'Random',
				value: 'random',
			},
		],
		monarch_size: [
			{
				label: '16x9',
				value: '1920x1080',
			}, {
				label: '9x16',
				value: '1080x1920',
			}, {
				label: '4x3',
				value: '1024x768',
			},
		],
	},
	monarch_feed_global_entertainment_news_videos: {
		monarch_size: [
			{
				label: '16x9 standard',
				value: '1920x1080',
			}, {
				label: '16x9 smaller',
				value: '1280x720',
			},
		],
		monarch_sort: [
			{
				label: 'Sequential',
				value: 'sequential',
			}, {
				label: 'Random',
				value: 'random',
			},
		],
	},
	monarch_feed_bright_spots_videos: {
		monarch_sort: [
			{
				label: 'Sequential',
				value: 'sequential',
			}, {
				label: 'Random',
				value: 'random',
			},
		],
		monarch_size: [
			{
				label: '16x9',
				value: '1920x1080',
			},
		],
	},
	monarch_feed_good_news_videos: {
		monarch_sort: [
			{
				label: 'Sequential',
				value: 'sequential',
			}, {
				label: 'Random',
				value: 'random',
			},
		],
		monarch_size: [
			{
				label: '16x9',
				value: '1920x1080',
			},
		],
	},
	monarch_feed_local_favorites: {
		monarch_sort: [
			{
				label: 'Sequential',
				value: 'sequential',
			}, {
				label: 'Random',
				value: 'random',
			},
		],
		monarch_size: [
			{
				label: '16x9',
				value: '1920x1080',
			}, {
				label: '9x16',
				value: '1080x1920',
			},
		],
	},
	monarch_feed_reuters_entertainment_news: {
		monarch_sort: [
			{
				label: 'Sequential',
				value: 'sequential',
			}, {
				label: 'Random',
				value: 'random',
			},
		],
		monarch_size: [
			{
				label: '16x9',
				value: '1920x1080',
			}, {
				label: '9x16',
				value: '1080x1920',
			}, {
				label: '4x3',
				value: '1024x768',
			},
		],
	},
	monarch_feed_the_list_images: {
		monarch_sort: [
			{
				label: 'Sequential',
				value: 'sequential',
			}, {
				label: 'Random',
				value: 'random',
			},
		],
		monarch_size: [
			{
				label: '16x9',
				value: '1920x1080',
			}, {
				label: '9x16',
				value: '1080x1920',
			}, {
				label: '4x3',
				value: '1024x768',
			},
		],
	},
	monarch_feed_the_list_videos: {
		monarch_sort: [
			{
				label: 'Sequential',
				value: 'sequential',
			}, {
				label: 'Random',
				value: 'random',
			},
		],
		monarch_size: [
			{
				label: '16x9',
				value: '1920x1080',
			}, {
				label: '9x16',
				value: '1080x1920',
			}, {
				label: '4x3',
				value: '1024x768',
			},
		],
	},
	monarch_feed_community_calendar: {
		monarch_theme: [
			{
				label: 'Clean Modern',
				value: 'clean-modern',
			}, {
				label: 'Cool Breeze',
				value: 'cool-breeze',
			}, {
				label: 'Gray',
				value: 'gray',
			}, {
				label: 'Light And Airy',
				value: 'light-airy',
			}, {
				label: 'Warmup',
				value: 'warmup',
			},
		],
		monarch_sort: [
			{
				label: 'Sequential',
				value: 'sequential',
			}, {
				label: 'Random',
				value: 'random',
			},
		],
		monarch_size: [
			{
				label: '16x9',
				value: '1920x1080',
			}, {
				label: '9x16',
				value: '1080x1920',
			}, {
				label: '4x3',
				value: '1024x768',
			},
		],
	},
	monarch_feed_creature_features: {
		monarch_size: [
			{
				label: '16x9',
				value: '1280x720',
			},
		],
		monarch_sort: [
			{
				label: 'Sequential',
				value: 'sequential',
			}, {
				label: 'Random',
				value: 'random',
			},
		],
	},
	monarch_feed_destinations: {
		monarch_size: [
			{
				label: '1280x720',
				value: '1280x720',
			}, {
				label: '768x432',
				value: '768x432',
			},
		],
		monarch_sort: [
			{
				label: 'Sequential',
				value: 'sequential',
			}, {
				label: 'Random',
				value: 'random',
			},
		],
	},
	monarch_feed_innovations: {
		monarch_size: [
			{
				label: '1280x720',
				value: '1280x720',
			}, {
				label: '768x432',
				value: '768x432',
			},
		],
		monarch_sort: [
			{
				label: 'Sequential',
				value: 'sequential',
			}, {
				label: 'Random',
				value: 'random',
			},
		],
	},
	monarch_feed_inspirations: {
		monarch_size: [
			{
				label: '16x9',
				value: '1920x1080',
			}, {
				label: '9x16',
				value: '1080x1920',
			},
		],
		monarch_sort: [
			{
				label: 'Sequential',
				value: 'sequential',
			}, {
				label: 'Random',
				value: 'random',
			},
		],
	},
	monarch_feed_pop_quiz_images: {
		monarch_sort: [
			{
				label: 'Sequential',
				value: 'sequential',
			},
		],
		monarch_size: [
			{
				label: '16x9',
				value: '1920x1080',
			}, {
				label: '9x16',
				value: '1080x1920',
			}, {
				label: '4x3',
				value: '1024x768',
			},
		],
	},
	monarch_feed_pop_quiz_videos: {
		monarch_sort: [
			{
				label: 'Sequential',
				value: 'sequential',
			}, {
				label: 'Random',
				value: 'random',
			},
		],
		monarch_size: [
			{
				label: '16x9',
				value: '1920x1080',
			}, {
				label: '9x16',
				value: '1080x1920',
			}, {
				label: '4x3',
				value: '1024x768',
			},
		],
	},
	monarch_feed_window_to_our_world: {
		monarch_size: [
			{
				label: '16x9',
				value: '1920x1080',
			}, {
				label: '9x16',
				value: '1080x1920',
			},
		],
		monarch_sort: [
			{
				label: 'Sequential',
				value: 'sequential',
			}, {
				label: 'Random',
				value: 'random',
			},
		],
	},
	monarch_feed_health_news_2_pak: {
		monarch_size: [
			{
				label: '16x9',
				value: '1920x1080',
			}, {
				label: '9x16',
				value: '1080x1920',
			},
		],
		monarch_sort: [
			{
				label: 'Sequential',
				value: 'sequential',
			}, {
				label: 'Random',
				value: 'random',
			},
		],
	},
	monarch_feed_healthy_bites_images: {
		monarch_size: [
			{
				label: '16x9',
				value: '1920x1080',
			}, {
				label: '9x16',
				value: '1080x1920',
			},
		],
		monarch_sort: [
			{
				label: 'Sequential',
				value: 'sequential',
			}, {
				label: 'Random',
				value: 'random',
			},
		],
	},
	monarch_feed_healthy_bites_videos: {
		monarch_sort: [
			{
				label: 'Sequential',
				value: 'sequential',
			}, {
				label: 'Random',
				value: 'random',
			},
		],
		monarch_size: [
			{
				label: '16x9',
				value: '1920x1080',
			}, {
				label: '9x16',
				value: '1080x1920',
			}, {
				label: '4x3',
				value: '1024x768',
			},
		],
	},
	monarch_feed_knowmore_living: {
		monarch_size: [
			{
				label: '16x9',
				value: '1280x720',
			},
		],
		monarch_sort: [
			{
				label: 'Sequential',
				value: 'sequential',
			}, {
				label: 'Random',
				value: 'random',
			},
		],
	},
	monarch_feed_local_health_conditions: {
		monarch_size: [
			{
				label: '16x9',
				value: '1920x1080',
			}, {
				label: '9x16',
				value: '1080x1920',
			},
		],
		monarch_sort: [
			{
				label: 'Sequential',
				value: 'sequential',
			}, {
				label: 'Random',
				value: 'random',
			},
		],
	},
	monarch_feed_missing_persons: {
		monarch_size: [
			{
				label: '16x9',
				value: '1920x1080',
			}, {
				label: '9x16',
				value: '1080x1920',
			},
		],
		monarch_sort: [
			{
				label: 'Sequential',
				value: 'sequential',
			}, {
				label: 'Random',
				value: 'random',
			},
		],
	},
	monarch_feed_fashion: {
		monarch_size: [
			{
				label: '16x9',
				value: '1920x1080',
			}, {
				label: '9x16',
				value: '1080x1920',
			},
		],
		monarch_sort: [
			{
				label: 'Sequential',
				value: 'sequential',
			}, {
				label: 'Random',
				value: 'random',
			},
		],
	},
	monarch_feed_community_events: {
		monarch_size: [
			{
				label: '16x9',
				value: '1920x1080',
			}, {
				label: '9x16',
				value: '1080x1920',
			},
		],
		monarch_sort: [
			{
				label: 'Sequential',
				value: 'sequential',
			}, {
				label: 'Random',
				value: 'random',
			},
		],
	},
	monarch_feed_ap_top_news_videos: {
		monarch_size: [
			{
				label: '853x480',
				value: '853x480',
			},
		],
		monarch_sort: [
			{
				label: 'Sequential',
				value: 'sequential',
			}, {
				label: 'Random',
				value: 'random',
			},
		],
	},
	monarch_feed_digital_broadcaster_package: {
		monarch_size: [
			{
				label: '853x480',
				value: '853x480',
			},
		],
		monarch_sort: [
			{
				label: 'Sequential',
				value: 'sequential',
			}, {
				label: 'Random',
				value: 'random',
			},
		],
	},
	monarch_feed_global_top_news_videos: {
		monarch_size: [
			{
				label: '1920x1080',
				value: '1920x1080',
			},
		],
		monarch_sort: [
			{
				label: 'Sequential',
				value: 'sequential',
			}, {
				label: 'Random',
				value: 'random',
			},
		],
	},
	monarch_feed_news_in_pictures_3_pak: {
		monarch_sort: [
			{
				label: 'Sequential',
				value: 'sequential',
			}, {
				label: 'Random',
				value: 'random',
			},
		],
		monarch_size: [
			{
				label: '16x9',
				value: '1920x1080',
			}, {
				label: '9x16',
				value: '1080x1920',
			}, {
				label: '4x3',
				value: '1024x768',
			},
		],
	},
	monarch_feed_reuters_german_news_videos: {
		monarch_size: [
			{
				label: '1920x1080',
				value: '1920x1080',
			},
		],
		monarch_sort: [
			{
				label: 'Sequential',
				value: 'sequential',
			}, {
				label: 'Random',
				value: 'random',
			},
		],
	},
	monarch_feed_reuters_national_news: {
		monarch_sort: [
			{
				label: 'Sequential',
				value: 'sequential',
			}, {
				label: 'Random',
				value: 'random',
			},
		],
		monarch_size: [
			{
				label: '16x9',
				value: '1920x1080',
			}, {
				label: '9x16',
				value: '1080x1920',
			}, {
				label: '4x3',
				value: '1024x768',
			},
		],
	},
	monarch_feed_reuters_odd_news: {
		monarch_sort: [
			{
				label: 'Sequential',
				value: 'sequential',
			}, {
				label: 'Random',
				value: 'random',
			},
		],
		monarch_size: [
			{
				label: '16x9',
				value: '1920x1080',
			}, {
				label: '9x16',
				value: '1080x1920',
			}, {
				label: '4x3',
				value: '1024x768',
			},
		],
	},
	monarch_feed_reuters_world_news: {
		monarch_sort: [
			{
				label: 'Sequential',
				value: 'sequential',
			}, {
				label: 'Random',
				value: 'random',
			},
		],
		monarch_size: [
			{
				label: '16x9',
				value: '1920x1080',
			}, {
				label: '9x16',
				value: '1080x1920',
			}, {
				label: '4x3',
				value: '1024x768',
			},
		],
	},
	monarch_feed_the_canadian_press: {
		monarch_sort: [
			{
				label: 'Sequential',
				value: 'sequential',
			}, {
				label: 'Random',
				value: 'random',
			},
		],
		monarch_size: [
			{
				label: '16x9',
				value: '1920x1080',
			}, {
				label: '9x16',
				value: '1080x1920',
			}, {
				label: '4x3',
				value: '1024x768',
			},
		],
	},
	monarch_feed_video_news_bites: {
		monarch_size: [
			{
				label: '16x9 standard',
				value: '1280x720',
			}, {
				label: '16x9 smaller',
				value: '853x480',
			},
		],
		monarch_sort: [
			{
				label: 'Sequential',
				value: 'sequential',
			}, {
				label: 'Random',
				value: 'random',
			},
		],
	},
	monarch_feed_todays_top_tweets: {
		monarch_sort: [
			{
				label: 'Sequential',
				value: 'sequential',
			}, {
				label: 'Random',
				value: 'random',
			},
		],
		monarch_size: [
			{
				label: '16x9',
				value: '1920x1080',
			}, {
				label: '9x16',
				value: '1080x1920',
			}, {
				label: '4x3',
				value: '1024x768',
			},
		],
	},
	monarch_feed_action_sports: {
		monarch_sort: [
			{
				label: 'Sequential',
				value: 'sequential',
			}, {
				label: 'Random',
				value: 'random',
			},
		],
		monarch_size: [
			{
				label: '16x9',
				value: '1920x1080',
			}, {
				label: '9x16',
				value: '1080x1920',
			}, {
				label: '4x3',
				value: '1024x768',
			},
		],
	},
	monarch_feed_reuters_sports_news: {
		monarch_sort: [
			{
				label: 'Sequential',
				value: 'sequential',
			}, {
				label: 'Random',
				value: 'random',
			},
		],
		monarch_size: [
			{
				label: '16x9',
				value: '1920x1080',
			}, {
				label: '9x16',
				value: '1080x1920',
			}, {
				label: '4x3',
				value: '1024x768',
			},
		],
	},
	monarch_feed_sports_central: {
		monarch_sort: [
			{
				label: 'Sequential',
				value: 'sequential',
			}, {
				label: 'Random',
				value: 'random',
			},
		],
		monarch_size: [
			{
				label: '16x9',
				value: '1920x1080',
			}, {
				label: '9x16',
				value: '1080x1920',
			}, {
				label: '4x3',
				value: '1024x768',
			},
		],
	},
	monarch_feed_spectrum_weather: {
		monarch_sort: [
			{
				label: 'Sequential',
				value: 'sequential',
			}, {
				label: 'Random',
				value: 'random',
			},
		],
		monarch_size: [
			{
				label: '16x9',
				value: '1920x1080',
			}, {
				label: '9x16',
				value: '1080x1920',
			}, {
				label: '4x3',
				value: '1024x768',
			},
		],
	},
	monarch_feed_weather_forecast_videos: {
		monarch_size: [
			{
				label: '1280x720',
				value: '1280x720',
			},
		],
		monarch_sort: [
			{
				label: 'Sequential',
				value: 'sequential',
			}, {
				label: 'Random',
				value: 'random',
			},
		],
	},
	monarch_feed_weather_graphics: {
		monarch_sort: [
			{
				label: 'Sequential',
				value: 'sequential',
			}, {
				label: 'Random',
				value: 'random',
			},
		],
		monarch_size: [
			{
				label: '16x9',
				value: '1920x1080',
			}, {
				label: '9x16',
				value: '1080x1920',
			}, {
				label: '4x3',
				value: '1024x768',
			},
		],
	},
	listings_scroller: {
		scroll_buttons: [
			{
				label: 'None',
				value: 0,
			},
			{
				label: 'Scroll Click and Hold',
				value: 1,
			},
			{
				label: 'Scroll Single Click',
				value: 2,
			},
		],
		default_keyboard: [
			{
				value: 'letters',
				label: 'QWERTY Letters',
			},
			{
				value: 'numbers',
				label: 'Numbers and Punctuation',
			},
			{
				value: 'specialChars',
				label: 'Special Characters',
			},
		],
	},
	raven_display: {
		time_zone: [
			{
				label: 'Coordinated Universal Time (UTC)',
				value: 'Coordinated Universal Time',
			},
			{
				label: 'Eastern Standard Time (EST)',
				value: 'Eastern Standard Time',
			},
			{
				label: 'Central Standard Time (CST)',
				value: 'Central Standard Time',
			},
			{
				label: 'Mountain Standard Time (MST)',
				value: 'Mountain Standard Time',
			},
			{
				label: 'Pacific Standard Time (PST)',
				value: 'Pacific Standard Time',
			},
			{
				label: 'Alaska Standard Time (AKST)',
				value: 'Alaska Standard Time',
			},
			{
				label: 'Hawaii-Aleutian Standard Time (HAST)',
				value: 'Hawaii-Aleutian Standard Time',
			},
		],
		raven_time_format: [
			{
				label: '12-hour',
				value: '12_hour',
			},
			{
				label: '24-hour',
				value: '24_hour',
			},
		],
	},
};

const settingsRegex = {
	'82597dc8-828c-11eb-ae1a-0d442d14e026': {
		regex: (val) => {
			return (/^https:\/\//).test(val.string);
		},
		errorMsg: 'You must input a https secure URL.',
	},
};

export const updatesAllowed = (pendingUpdates, systemMap) => {
	let updatesAreAllowed = true;
	const errorMsgs = [];

	let flatData = {};
	for (let tlcFlatData of Object.values(systemMap)) {
		flatData = Object.assign({}, flatData, tlcFlatData);
	}

	for (let [ m1Key, m1Data, ] of Object.entries(pendingUpdates)) {
		if (m1Key.startsWith('template_skeleton.')) {
			if (m1Key.endsWith('.data')) {
				flatData = Object.assign({}, flatData, JSON.parse(m1Data));
			}
		}
	}

	const broodToPelicanMap = {};

	for (let [ m1Key, m1Data, ] of Object.entries(flatData)) {
		if (m1Data['type'] === 'pelican') {
			const broodM1Key = m1Data['parent'];

			if (!broodToPelicanMap[broodM1Key]) {
				broodToPelicanMap[broodM1Key] = [];
			}

			const pelicanLabel = flatData[m1Key]?.custom_content_sidebar_label || '';
			// pending deletions should not be blocked
			let pendingDeletion = false;
			for (let [ key, val, ] of Object.entries(pendingUpdates)) {
				if (key === `${broodM1Key}.${m1Key}` && val === false) {
					pendingDeletion = true;

					break;
				}
			}
			if (pendingDeletion) {
				continue;
			}

			broodToPelicanMap[broodM1Key].push(pelicanLabel);
		}
	}

	let duplicatePelicanLabels = false;
	for (let pelicanLabels of Object.values(broodToPelicanMap)) {
		if ((new Set(pelicanLabels)).size !== pelicanLabels.length) {
			duplicatePelicanLabels = true;

			break;
		}
	}

	if (duplicatePelicanLabels) {
		errorMsgs.push('Duplicate pelican labels are not allowed.');
		updatesAreAllowed = false;
	}

	Object.entries(pendingUpdates).forEach(([ key, val, ]) => {
		const splitKey = key.split('.');

		if (splitKey.length === 4) {
			const m1 = splitKey[0], m2 = splitKey[2];

			if (m1 === 'component' && m2 === 'setting') {
				const m2UUID = splitKey[3];
				if (Object.keys(settingsRegex).includes(m2UUID)) {
					if ((!settingsRegex[m2UUID].regex(val) && val !== false && val.string !== '')) {
						errorMsgs.push(settingsRegex[m2UUID].errorMsg);
						updatesAreAllowed = false;
					}
				}
			}
		}
	});

	const compositeErrorMsg = errorMsgs.reduce((accum, curr) => {
		return accum + '\n- ' + curr;
	}, '');

	return [ updatesAreAllowed, compositeErrorMsg, ];
};

export const dropdownStyles = {
	control: (provided, state) => {
		return {
			...provided,
			background:  '#fff',
			borderColor: '#9e9e9e',
			minHeight:   '26px',
			height:      'auto',
			fontSize:    '0.8rem',
			boxShadow:   state.isFocused ? null : null,
		};
	},

	valueContainer: (provided) => {
		return {
			...provided,
			minHeight: '26px',
			maxHeight: '120px',
			overflowY: 'auto',
			padding:   '0 6px',
		};
	},

	input: (provided, _) => {
		return {
			...provided,
			margin:    '0px',
			padding:   '0px',
		};
	},
	indicatorsContainer: (provided, _) => {
		return {
			...provided,
			height: '26px',
		};
	},
	menu: (provided) => {
		return {
			...provided,
			zIndex: 10,
		};
	},
};


export const multiSummaryDropdownStyles = {
	...dropdownStyles,

	valueContainer: (provided) => {
		return {
			...dropdownStyles.valueContainer(provided),
			maxHeight: 'none',
			overflowY: 'hidden',
			flexWrap:  'nowrap',
		};
	},
};